import { InspectDescriptions } from "@/model/InspectGensha";
import {
  InspectRecommendCategory,
  InspectRecommendSubItem
} from "@/model/InspectRecommend";

export const WORK_AND_BUHIN_MODE = {
  NONE: 0,
  INSPECT: 1,
  JIZEN_RECOMMEND: 2,
  INSPECT_LINE: 3,
  RECOMMEND: 4,
  PART_SELECTION_INSPECT: 5,
  PART_SELECTION_RECOMMEND: 6
};

export type WorkAndBuhinMode =
  typeof WORK_AND_BUHIN_MODE.NONE |
  typeof WORK_AND_BUHIN_MODE.INSPECT |
  typeof WORK_AND_BUHIN_MODE.JIZEN_RECOMMEND |
  typeof WORK_AND_BUHIN_MODE.INSPECT_LINE |
  typeof WORK_AND_BUHIN_MODE.RECOMMEND |
  typeof WORK_AND_BUHIN_MODE.PART_SELECTION_INSPECT |
  typeof WORK_AND_BUHIN_MODE.PART_SELECTION_RECOMMEND;

export interface WorkAndBuhinUiState {
  showWork?: boolean;
  showValue?: boolean;
  isSaving?: boolean;
}

export interface InspectWorkAndBuhinData
  extends InspectDescriptions, WorkAndBuhinUiState {}

export interface JizenRecommendWorkAndBuhinData
  extends InspectRecommendSubItem, WorkAndBuhinUiState {}

export interface InspectLineWorkAndBuhinData
  extends InspectDescriptions, WorkAndBuhinUiState {}

export interface RecommendWorkAndBuhinData
  extends InspectRecommendSubItem, WorkAndBuhinUiState {}

export interface PartSelectionInspectWorkAndBuhinData
  extends InspectDescriptions, WorkAndBuhinUiState {}

export interface PartSelectionRecommendWorkAndBuhinData
  extends WorkAndBuhinUiState {
  sknRecommendInspectCategoryId: InspectRecommendCategory["sknRecommendInspectCategoryId"];
  sknRecommendInspectCategoryNm: InspectRecommendCategory["sknRecommendInspectCategoryNm"];
  status?: InspectRecommendCategory["status"];
  kingakuZn?: InspectRecommendCategory["kingakuZn"];
  kingakuZk?: InspectRecommendCategory["kingakuZk"];
  subItems: InspectRecommendSubItem[];
  seibiList: InspectRecommendSubItem[];
}

export type WorkAndBuhinData =
  InspectWorkAndBuhinData |
  JizenRecommendWorkAndBuhinData |
  InspectLineWorkAndBuhinData |
  RecommendWorkAndBuhinData |
  PartSelectionInspectWorkAndBuhinData |
  PartSelectionRecommendWorkAndBuhinData;

export type WorkAndBuhinRuntimeData = WorkAndBuhinData & {
  [key: string]: any;
};
